import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListINDO = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaINDO.socialmediaListINDO);
    const [socialmediaListINDO, setSocialmedialListINDO] = useState(s);
    const loading = useSelector(state => state.socialmediaINDO.loading);
    const e = useSelector(state => state.socialmediaINDO.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaINDO.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.INDONESIAN_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListINDO}
            setSocialmedialList={setSocialmedialListINDO}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}